import { AllEvents } from "./all-events";
import { globalStore } from "./global-store";
import { Event } from "./types";

export const triggerEvent = <T extends AllEvents, K extends T["type"]>(
  type: K
) => (payload: T extends Event<K, infer B> ? B : never) => {
  const event: AllEvents = {
    type,
    payload,
  } as any;
  // TODO: Fix Typing

  globalStore.next(event);
  return payload;
};

export const triggerErrorEvent = (payload: Error) => {
  globalStore.next({
    type: "ERROR",
    payload,
  });
  return Promise.reject(payload);
};
